import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import tomek from "../images/DSC_8884.jpg";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";

export default function About() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Helmet>
        <title>Fotografia Wnętrz i Nieruchomości | Tomasz Fotograf</title>
        <meta
          name="description"
          content="Profesjonalna fotografia wnętrz, nieruchomości, apartamentów, domów i hoteli. Zdjęcia, które zwiększają zainteresowanie ofertą."
        />
      </Helmet>
      <Menu />
      <section className="section section-gray section-about" key="sectiongray">
        <AnimatePresence>
          <motion.div
            className="h1a"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row1">
              <Col sm={12} md={4}>
                <p className="h1a">
                  Tomasz Jaskulski - fotograf nieruchomości i wnętrz
                </p>
                <br />
                <p className="h4a">
                  Doświadczenie filmowe i reklamowe | Warszawa i okolice
                </p>
              </Col>
              <Col md={8}>
                <ImageZoom
                  src={tomek}
                  alt="tomek"
                  className="responsive-image"
                />
              </Col>
            </Row>
            <br />
            <Row key="row2">
              <Col sm={12} md={12}>
                <p className="h4a">
                  Zanim zająłem się fotografią nieruchomości, przez wiele lat
                  pracowałem w branży filmowej i reklamowej. <br />
                  Brałem udział w produkcjach fabularnych, dokumentalnych i
                  reklamowych — moje doświadczenie zawodowe można zweryfikować w
                  ogólnopolskiej bazie branżowej{" "}
                  <b>
                    <a
                      href="https://filmpolski.pl/fp/index.php?osoba=1158193"
                      style={{ textDecoration: "none", color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      FilmPolski
                    </a>
                  </b>
                  .
                </p>
                <p className="h4a">
                  Praca na planach filmowych nauczyła mnie myślenia obrazem pod
                  presją czasu. Liczy się szybkie podejmowanie decyzji,
                  umiejętność pracy w trudnych warunkach i koncentracja na
                  efekcie końcowym. To podejście przeniosłem dziś do fotografii
                  wnętrz i fotografii nieruchomości.
                </p>
                <p className="h4a">
                  Każde wnętrze traktuję jak scenę. Analizuję światło, proporcje
                  i rytm przestrzeni, dbając o spójną kompozycję i detale, które
                  budują atrakcyjny obraz. Fotografia nieruchomości ma nie tylko
                  dobrze wyglądać — powinna opowiadać historię miejsca i
                  wzbudzać zainteresowanie już przy pierwszym kontakcie z
                  ofertą.{" "}
                </p>
                <p className="h4a">
                  Doświadczenie filmowe nauczyło mnie również rozwiązywania
                  problemów w każdych warunkach. Trudne światło, ciasne
                  pomieszczenia, puste lokale deweloperskie czy ograniczony czas
                  realizacji to sytuacje, z którymi pracuję na co dzień.
                </p>
                <p className="h4a">
                  Współpracuję z projektantami wnętrz, dekoratorami i
                  scenografami, dzięki czemu mogę oferować zarówno klasyczny
                  staging, staging premium, jak i fotorealistyczne wizualizacje
                  pustych przestrzeni. Pozwala to skutecznie zaprezentować
                  potencjał nieruchomości, także tych wymagających dodatkowego
                  przygotowania.{" "}
                </p>
                <p className="h4a">
                  Fotografia wnętrz i nieruchomości to dla mnie połączenie
                  techniki, estetyki i narracji wizualnej — a filmowe
                  doświadczenie jest fundamentem każdej realizacji.
                </p>
              </Col>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
